/* eslint-disable */

class  util {
     removeSpecialChars(key : any) {
        return key?.trim().toLowerCase()?.replace(/[^a-z0-9 _-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
    }
}


export default new util();